import {
  Dialog,
  DialogContent,
  Grid2,
  IconButton,
  Stack,
  Switch,
  Typography,
} from "@mui/material";
import { IconX } from "@tabler/icons-react";
import Loading from "./Loading";
import { useMutation, useQuery } from "@tanstack/react-query";
import {
  listMarketplaceOnStores,
  updateMarketplaceOnStores,
} from "../services/products";
import { toast } from "react-toastify";

const PartnersStore = ({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}) => {
  const { data, isLoading, isFetching, refetch }: any = useQuery({
    queryKey: ["listMarketplaceOnStores"],
    queryFn: async () => await listMarketplaceOnStores(),
    initialData: [],
  });

  const { mutate, isPending } = useMutation({
    mutationFn: updateMarketplaceOnStores,
    onSuccess: () => {
      onClose();
      refetch();
      toast.success("Status alterado com sucesso");
    },

    onError: (e: { response: { data: { message: string } } }) => {
      toast.error(String(e?.response?.data?.message) || "Erro!");
    },
  });

  return (
    <Dialog maxWidth="xs" open={open} onClose={() => onClose()}>
      <Loading loading={isPending || isLoading || isFetching} />
      <DialogContent sx={{ backgroundColor: "secondary.main" }}>
        <Grid2 container spacing={2} padding={1}>
          <Grid2 size={{ xs: 10, md: 11 }}>
            <Typography variant="h2" fontSize={26} fontWeight={600}>
              Lojas parceiras
            </Typography>
          </Grid2>
          <Grid2 size={{ xs: 2, md: 1 }}>
            <IconButton onClick={() => onClose()}>
              <IconX style={styles.iconStyle} />
            </IconButton>
          </Grid2>
          <Grid2 container spacing={2}>
            {data?.map((item: any) => {
              return (
                <Grid2 key={item.marketplaceId} size={12}>
                  <Stack
                    sx={{
                      padding: 2,
                      borderRadius: 2,
                      gap: 2,
                      backgroundColor: item.status
                        ? "primary.dark"
                        : "secondary.dark",
                    }}
                  >
                    <Stack
                      direction={{ xs: "column", md: "row" }}
                      alignItems={{ xs: "flex-start", md: "center" }}
                      sx={{
                        justifyContent: "space-between",
                      }}
                    >
                      <Typography fontSize={20} fontWeight={700}>
                        {item?.marketplace?.name}
                      </Typography>
                      <Stack
                        sx={{
                          flexDirection: "row",
                          alignItems: "center",
                          gap: 1,
                        }}
                      >
                        <Typography fontSize={14}>
                          Status: {item.status ? "Ativo" : "Inativo"}
                        </Typography>
                        <Switch
                          checked={item.status}
                          onChange={() =>
                            mutate({
                              marketplaceId: item.marketplaceId,
                              status: !item.status,
                            })
                          }
                        />
                      </Stack>
                    </Stack>
                    <Stack>
                      <Typography
                        fontSize={14}
                        color={
                          item.status
                            ? "primary.light"
                            : "secondary.contrastText"
                        }
                      >
                        Você recebe {item?.marketplace?.comission}% de comissão
                        em cada compra feita nessa loja.
                      </Typography>
                    </Stack>
                  </Stack>
                </Grid2>
              );
            })}
          </Grid2>
        </Grid2>
      </DialogContent>
    </Dialog>
  );
};

const styles = {
  stackStyle: {
    flexDirection: "row",
    alignItems: "center",
    gap: 1,
    padding: 1,
    borderRadius: 2,
    backgroundColor: "secondary.dark",
  },
  iconStyle: {
    color: "primary.main",
  },
};

export default PartnersStore;
